import { createReducer, on } from '@ngrx/store';
import { OpenFullscreenModalActions } from '@src/suite/common/store/fullscreen';
import { ApplicationActions } from '@src/suite/common/store/navigation/actions/application.actions';
import { LiveActions, LiveApiActions } from '@src/suite/live/store/actions/live.actions';
import { LiveState } from '@src/suite/live/store/models/live.models';

export const initialState: LiveState = {
    rundowns: [],
    currentRundown: null,
    rundownStories: {},
    storedLayouts: null,
    storedViewStates: null,
    currentRundownViewState: null,
    hasGroupLayout: false,
    hasMobileGroupLayout: false,
    hasMobileLayout: false,
    hasUserLayout: false,
};

export const liveReducer = createReducer(
    initialState,
    on(LiveApiActions.loadRundownsSuccess, (state, { rundowns }): LiveState => {
        return {
            ...state,
            rundowns: [
                ...state.rundowns,
                ...rundowns.filter(ro => {
                    return !state.rundowns.find(item => item.Guid === ro.Guid);
                }),
            ],
        };
    }),
    on(LiveApiActions.loadRundownStoredLayoutsSuccess, (state, { data }): LiveState => {
        return {
            ...state,
            storedLayouts: new Map(data?.StoredLayouts?.map(layout => [layout, null])),
            hasGroupLayout: data.HasGroupLayout,
            hasMobileGroupLayout: data.HasMobileGroupLayout,
            hasUserLayout: data.HasUserLayout,
            hasMobileLayout: data.HasMobileLayout,
        };
    }),
    on(LiveApiActions.loadRundownLayoutSuccess, (state, { name, data }): LiveState => {
        const newStoredLayout = new Map(state.storedLayouts);
        newStoredLayout.set(name, data);
        return {
            ...state,
            storedLayouts: newStoredLayout,
        };
    }),
    on(LiveApiActions.loadRundownViewStatesSuccess, (state, { data }): LiveState => {
        return {
            ...state,
            storedViewStates: data,
        };
    }),
    on(ApplicationActions.setCurrentRundownViewState, (state, { guid }): LiveState => {
        return {
            ...state,
            currentRundownViewState: state?.storedViewStates?.find(view => view.Guid === guid) || null,
        };
    }),
    on(
        OpenFullscreenModalActions.closeRundownFullscreenModal,
        (state): LiveState => ({
            ...state,
            currentRundown: null,
        })
    ),
    on(LiveActions.removeStoredLayout, (state, { layoutName }): LiveState => {
        const newStoredLayout = new Map(state.storedLayouts);
        newStoredLayout.delete(layoutName);
        return {
            ...state,
            storedLayouts: newStoredLayout,
        };
    })
);
